import { isEmpty } from 'lodash'

import { useBucket } from '@mc/experiments-react'
import { usePromotion } from '@mc/promo-utils'
import { useStaticData } from '@mc/static-data-react'

// https://app.growthbook.io/features/pen-4391_v1
export const EMAIL_CAPTURE_PROMO_MODAL = 'pen-4391_v1'

export const usePromoModalEmailCaptureExp = () => {
  const { isPromotionOn } = usePromotion()
  const bucket = useBucket(EMAIL_CAPTURE_PROMO_MODAL)
  const isPromoModalEmailCaptureExp =
    !!isPromotionOn && bucket?.includes('variant')

  const { cartEmailCookie, promoModalEmailCaptureCookie } = useStaticData<{
    cartEmailCookie?: string
    promoModalEmailCaptureCookie?: string
  }>()

  return {
    isPromoModalEmailCaptureExp,
    skipAccountStepPromoEmailCaptureExp:
      isPromoModalEmailCaptureExp &&
      !isEmpty(cartEmailCookie) &&
      !!promoModalEmailCaptureCookie,
    cartEmailCookie,
  }
}
